import App from './App';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

ReactDOM.render(<BrowserRouter> <App/> </BrowserRouter>, document.getElementById('root'));
serviceWorker.unregister();